module.exports = __webpack_public_path__ + "img/II-17.2b38a0e3.svg";